import { render, staticRenderFns } from "./SearchTermItem.vue?vue&type=template&id=e50d8b4c&"
import script from "./SearchTermItem.vue?vue&type=script&lang=js&"
export * from "./SearchTermItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports